module.exports = __webpack_public_path__ + "img/ico2.117cbded.png";